<template>
    <div v-if="showSurvey" class="survey-link alert alert-primary active">
    Please tell us about your order experience: <a href="https://brandlyinc.typeform.com/to/adZTzG">take the last mini-survey now</a>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  props: ['details'],
  computed: {
    ...mapGetters(['orderVoucher']),
    showSurvey() {
      return this.orderVoucher && this.orderVoucher.description === 'FREE2018';
    }
  }
}
</script>
<style <style lang="scss" scoped>
.survey-link {
  width: 60%;
  margin: 0 auto;
  min-width: 300px;
  font-weight: bold !important;
  font-size: larger;
  text-align: center;
  a { text-decoration: underline; }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SurveyLink.vue